export const useSetupHeadphoneListener = (): void => undefined;
